import { Stack, styled } from "@mui/material"

export const AdaptiveStack = styled(Stack)(() => ({
  alignItems: "center",
  marginBottom: "16px",
  padding: "0 5px",

  "@media (min-width: 638px)": {
    padding: "0px 32px",
  },

  "& .MuiPagination-ul": {
    display: "flex",
    justifyContent: "center",
  },

  "& .MuiPaginationItem-root": {
    background: "transparent",
    overflow: "hidden",
    color: "var(--Schemes-On-Surface-Variant)",

    "&:hover": {
      background: "var(--Schemes-Surface-Container)",
    },

    "&.Mui-selected": {
      background: "var(--Schemes-Secondary-Container) !important",
      color: "var(--Schemes-Primary) !important",
      fontWeight: "500 !important",
    },
  },
}))
